import { createCustomInterceptorInstance } from '@fundacao/shared-components/esm/ie/renovacao';
import axios, { AxiosInstance } from 'axios';
import { Curso } from '../../models/curso';

class CursosService {
  private instance: AxiosInstance;

  constructor() {
    this.instance = createCustomInterceptorInstance(process.env.REACT_APP_LEGADO_API);
    this.instance.defaults.headers.common[
      'Authorization'
    ] = `${localStorage.getItem('tokenIES')}`;
  }

  async getBolsasCurso(bolsaId: number): Promise<Curso[]> {
    const resp = await this.instance
      .get(`/bolsas-curso/${bolsaId}`)
      .catch((err) => Promise.reject(err.response));
    return resp.data;
  }
}

export default new CursosService();
